export const notify = {
    /** `action: { text, onClick }` añade un botón al aviso (por ejemplo «Ver»): al pulsarlo se cierra y se ejecuta. */
    toast(text, { icon = '', duration = 2200, position = 'bottom', action = null } = {}) {
        const app = window.app;
        if (app && app.toast) {
            const esc = (v) => String(v).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
            const tt = app.toast.create({
                text: (icon ? '<span class="mi" style="vertical-align:-6px;margin-right:8px">' + icon + '</span>' : '') + text
                    + (action ? ' <a href="#" data-toast-action class="toast-action" style="margin-left:12px;font-weight:700;text-decoration:underline;color:inherit">' + esc(action.text) + '</a>' : ''),
                position,
                closeTimeout: duration,
                cssClass: 'app-toast'
            });
            tt.open();
            if (action) {
                const el = tt.el && (tt.el[0] || tt.el);
                const link = el && el.querySelector ? el.querySelector('[data-toast-action]') : null;
                if (link) link.addEventListener('click', (e) => { e.preventDefault(); try { tt.close(); } catch (err) { /* ya cerrado */ } action.onClick(); });
            }
        } else {
            console.log('[toast]', text);
        }
    },

    error(text) {
        this.toast(text, { icon: 'error_outline', duration: 3500 });
    },

    confirm(text, title, onOk, onCancel) {
        const app = window.app;
        if (app && app.dialog) {
            app.dialog.confirm(text, title, onOk, onCancel);
        } else if (window.confirm(text)) {
            onOk();
        } else if (onCancel) {
            onCancel();
        }
    }
};
